import { authReducer } from "../Authentication/authSlice";
import { sendCodeReducer } from "../Code/sendCodeSlice";
import { codeVerifyReducer } from "../Code/codeVerifySlice";
import { servicesReducer } from "../Services/servicesSlice";
import { productsReducer } from "../Products/productsSlice";
import { addToCartReducer } from "../Cart/addToCartSlice";
import { getFromCartReducer } from "../Cart/getFromCartSlice";
import { getEmploeesReducer } from "../Employees/emploeesSlice";
import { orderReducer } from "../Order/orderSlice";
import { orderIdReducer } from "../Order/orderIdSlice";
import { categoriesReducer } from "../Categories/categoriesSlice";
import { orderDetailsReducer } from "../Order/orderDetailsSlice";
import { reservationDetailsSlice } from "../Order/reservationDetailsSlice";

const reducers = {
  auth: authReducer,
  sendCode: sendCodeReducer,
  codeVerify: codeVerifyReducer,
  services: servicesReducer,
  products: productsReducer,
  addToCart: addToCartReducer,
  getFromCart: getFromCartReducer,
  getEmploees: getEmploeesReducer,
  getOrder: orderReducer,
  getOrderId: orderIdReducer,
  getCategories: categoriesReducer,
  orderDetails: orderDetailsReducer,
  reservationDetails: reservationDetailsSlice,
};

export default reducers;
